import { type OperationalOnboardingTask } from '../../../models';

export const getNumberOfRemainingTasks = (
  operationalOnboardingTasks: OperationalOnboardingTask[],
) => {
  return operationalOnboardingTasks.filter(
    (task) => task.status !== 'done' && task.status !== 'skipped',
  ).length;
};
